import React, { useEffect, useRef, useState } from 'react';

import Layout from '../../wrappers/layout';

import PageHeader from '../../shared/page-header';
import { Card, Tab, Tabs, Button, Form, InputGroup, OverlayTrigger, Tooltip } from 'react-bootstrap';
import CurrencyInput from 'react-currency-input-field';
// import { Form } from 'formik';
import './styles.css';
import RadioCard from 'pages/signup/components/radioCard';
// import  './faq.css';
// var perf =require('./faq.html');
import { Formik, Field, Form as FormikForm, ErrorMessage } from 'formik';
import { useHistory, useLocation } from 'react-router-dom';
import moment from 'moment';
import { userStore } from 'store/UserStore';
import { formatAmount, makeQuery } from '../../utils';
import SipHttp from './sip.service';
import * as Yup from 'yup';
import SipSummary from './SipSummary';
import useRazorpay, { RazorpayOptions } from 'react-razorpay';
import { ToastContainer, toast } from 'react-toastify';
// import ConfettiExplosion, { ConfettiProps } from 'react-confetti-explosion';
import PaymentFailedModal from './PaymentFailedModal';
import infoIco from 'assets/images/i-circle.svg';
// import Datetime from 'react-datetime';

const metalMapping = {
  Ag: 'SILVER',
  Au: 'GOLD',
  Pt: 'PLATINUM',
  Pd: 'PALLADIUM',
};

// const mediumProps: ConfettiProps = {
//   force: 0.9,
//   duration: 3500,
//   particleCount: 200,
//   width: 1000,
// };

interface PropsType { }

const SipSavingPlan: React.FC<PropsType> = () => {
  const location = useLocation();
  const data = location.state;
  const today = new Date();
  const today2 = new Date();
  const today5 = new Date();
  const todayDate = moment(today.setDate(today.getDate())).format('YYYY-MM-DD');
  const twodaysAhead = moment(today2.setDate(today2.getDate() + 2)).format(
    'YYYY-MM-DD'
  );
  const fivedaysAhead = moment(today5.setDate(today5.getDate() + 5)).format(
    'YYYY-MM-DD'
  );
  const thirtyDaysAhead = moment().add(30, 'days').format('YYYY-MM-DD');

  const metalName = metalMapping[data?.sipMetalType] || data?.sipMetalType;

  const [expand, setExpand] = useState(0);
  // const [sipPlanName, setSipPlanName] = useState('');
  const [investInterval, setInvestInterval] = useState(data.sipInterval);
  const [metalType, setMetalType] = useState(data.sipMetalType);
  const [sipAmount, setSipAmount] = useState(data.sipAmount);
  const [sipGram, setSipGram] = useState(data.sipGram);
  const [couponCode, setCouponCode] = useState(data.couponCode);
  const [sipType, setSipType] = useState('');
  const [emandates, setEmandates] = useState('withMandateUPI');
  const [sipMethod, setSipMethod] = useState('payemandate');
  const [termCondition, setTermCondition] = useState();
  const [startDate, setStartDate] = useState<any | null>(fivedaysAhead);
  // const [manualstartDate, setmanualStartDate] = useState<any | null>(todayDate);
  const [emandateList, setEmandateList] = useState([]);
  const [dislaySipSummary, setDislaySipSummary] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedBank, setSelectedBank] = useState('');
  const [isConsented, setIsConsented] = useState(false);
  const [investAmtField, setInvestAmtField] = useState(false);
  const [investGramField, setInvestGramField] = useState(false);
  const [isCouponApplied, setIsCouponApplied] = useState(false);
  const [showModel, setShowModel] = useState(false);
  const [couponData, setCouponData] = useState<any>(null);
  const [errorMessage, setErrorMessage] = useState<any>(null);
  const [couponValidationError, setCouponValidationError] = useState(null);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [showConfetti, setShowConfetti] = useState(true);
  const [sipDailyThreshold, setSipDailyThreshold] = useState('50');
  const [sipDailyMaxValue, setSipDailyMaxValue] = useState('1500');
  // const [sipPlanName, setSipPlanName] = useState<any>('');
  const [isSipAutoRenew, setIsSipAutoRenew] = useState<boolean>(false);

  const [customerId, setUser, user, selectedAccount] = userStore(
    (state: any) => [
      state.customerId,
      state.setUser,
      state.user,
      state.selectedAccount,
    ]
  );
  const [newSIP, setNewSIP] = useState({
    plan_name: '',
    frequency: data.sipInterval,
    installment_amt: data.sipAmount,
    grams: data.sipGram,
    metal: data.sipMetalType,
    duration: '3',
    start_date: data?.sipInterval == 'daily' ? twodaysAhead : fivedaysAhead,
    bank: '',
    customer_id: customerId,
    is_payment_manual: false,
    isupi: false,
    discount_name: data.couponCode,
    is_auto_renew: isSipAutoRenew
  });
  console.log('startDate', startDate, newSIP?.start_date, newSIP);
  const [razorpay, setRazorpay] = useState<any>({
    customerId: customerId,
    amount: null,
    paymentMethod: 'NEBK',
  });

  const history = useHistory();
  const dateForPicker = (dateString) => {
    return moment(new Date(dateString)).format('YYYY-MM-DD');
  };

  const dateFromDateString = (dateString) => {
    return moment(new Date(dateString)).format('YYYY-MM-DD');
  };

  const getEmandateList = async () => {
    try {
      const query = makeQuery({
        customerId: customerId,
        status: 'CONFIRMED',
        user_id: user?.userId,
      });
      SipHttp.getEmandatesList(query, customerId)
        .then((res: any) => {
          if (res && res.data.data[0]) {
            const objectAsArray: any = Object.values(res?.data?.data[0]);
            setEmandateList(res?.data?.data);
            // setEmandates('withoutMandate');
            setNewSIP({
              ...newSIP,
              // bank: res?.data?.data[0]?.bank,
            });
            //@ts-ignore
            validation.bank = Yup.string().required('Please enter bank.');
          }
        })
        .catch((err) => {
          console.error('API Error:', err);
        });
    } catch (err) {
      console.log(err);
    }
  };

  const validation = Yup.object().shape({
    // installment_amt: Yup.string().nullable().required('Please enter amount or gram'),
    // grams: Yup.string().nullable().required('Please enter gram'),
    // plan_name: Yup.string().required('Please enter plan name.'),
    // plan_name: Yup.string()
      // .matches(
      //   /^[A-Za-z0-9\s]+$/,
      //   'Plan name must only contain letters and numbers'
      // )
      // .required('Please enter plan name.'),

    bank: Yup.string(),
    // duration: Yup.string().required('Please enter frequency'),
    // start_date: Yup.string().required('valid date'),
  });

  useEffect(() => {
    // setSipPlanName(`${data?.sipInterval?.toUpperCase()}_${metal}_${data?.sipAmount}`)
    // setNewSIP({
    //   ...newSIP,
    //   plan_name: `${newSIP?.frequency?.toUpperCase()}_${metalName}_${
    //     data?.sipAmount
    //   }`,
    // });
    if (data.couponCode.length > 0) {
      setIsCouponApplied(true);
    }
  }, [data]);

  useEffect(() => {
    getEmandateList();
    if (data?.sipAmount) {
      setInvestGramField(true);
    } else {
      setInvestAmtField(true);
    }
  }, []);

  useEffect(() => {
    if (showConfetti) {
      const timer = setTimeout(() => {
        setShowConfetti(false);
      }, 1000); // Automatically hide confetti after 1 second

      return () => clearTimeout(timer); // Cleanup timer
    }
  }, [showConfetti]);

  const dateForState = (date) => {
    return date ? date.split('-').reverse().join('-') : '';
  };

  const validateGramsforMetal = () => {
    let gramErr = true;
    switch (metalType) {
      case 'Ag':
        if (metalType == 'Ag' && (newSIP?.grams < 2 || newSIP?.grams > 1000)) {
          toast.error('Silver should be between 2g to 1kg');
          return gramErr;
          break;
        }
      case 'Pt':
        if (metalType == 'Pt' && (newSIP?.grams < 1 || newSIP?.grams > 20)) {
          toast.error('Platinum should be between 1g to 20g');
          return gramErr;

          break;
        }

      case 'Pd':
        if (metalType == 'Pd' && (newSIP?.grams < 1 || newSIP?.grams > 15)) {
          toast.error('Palladium should be between 1g to 15g');
          return gramErr;

          break;
        }
      case 'Au':
        if (metalType == 'Au' && (newSIP?.grams < 1 || newSIP?.grams > 10)) {
          toast.error('Gold should be between 1g to 10g');
          return gramErr;

          break;
        }
      default:
        return false;
    }
  };
  const sipDailyLimitCheck = async () => {
    try {
      const res = await SipHttp.sipDailyLimit({ partnerId: user?.partner?.id });
      setSipDailyThreshold(res?.data?.data?.partnerQuotationValue);
      setSipDailyMaxValue(res?.data?.data?.maxSipValue);
    } catch (error) {
      console.log(error);
    }
  };
  const createSIP = async (values, { setErrors }) => {
    const startDate = moment(newSIP?.start_date, 'YYYY-MM-DD');

    if (!startDate.isValid()) {
      return toast.error('Please select a valid start date.');
    }

    if (startDate.isBefore(moment(todayDate, 'YYYY-MM-DD'))) {
      return toast.error('Start date cannot be in the past.');
    }

    if (startDate.isAfter(moment(thirtyDaysAhead, 'YYYY-MM-DD'))) {
      return toast.error(
        `Start date cannot be more than 30 days from today (${moment(thirtyDaysAhead).format('DD-MM-YYYY')}).`
      );
    }
    // console.log("Inside the create SIP funct")

    if (newSIP?.plan_name == '') {
      let metalName = metalMapping[newSIP?.metal]
      setNewSIP({
        ...newSIP,
        plan_name: `${newSIP?.frequency?.toUpperCase()}_${metalName}_${
          newSIP?.installment_amt
        }`,
      });
    }
    if (emandates == 'withoutMandate' && newSIP?.bank == '') {
      return toast.error('Select Bank');
    } else if (
      Number(newSIP?.installment_amt) == null &&
      newSIP?.grams == null
    ) {
      return toast.error('Please enter investment amount ');
    } else if (
      (Number(newSIP?.installment_amt) < Number(sipDailyThreshold) ||
        Number(newSIP?.installment_amt) > Number(sipDailyMaxValue)) &&
      newSIP?.frequency == 'daily'
    ) {
      return toast.error(
        `Amount should be between ₹${sipDailyThreshold} to ₹${sipDailyMaxValue} `
      );
    } else if (
      (Number(newSIP?.installment_amt) < 100 ||
        Number(newSIP?.installment_amt) > 100000) &&
      newSIP?.frequency !== 'daily'
    ) {
      return toast.error('Amount should be between ₹100 to ₹100000 ');
    } else if (
      sipMethod == 'payemandate' &&
      investInterval == 'daily' &&
      newSIP?.start_date < twodaysAhead
    ) {
      return toast.error(
        `Start date should be greater than or equal to ${moment(
          twodaysAhead
        ).format('DD-MM-YYYY')}`
      );
    } else if (
      sipMethod == 'payemandate' &&
      investInterval !== 'daily' &&
      newSIP?.start_date < fivedaysAhead
    ) {
      return toast.error(
        `Start date should be greater than or equal to ${moment(
          fivedaysAhead
        ).format('DD-MM-YYYY')}`
      );
    } else if (sipMethod == 'paymanual' && newSIP?.start_date < todayDate) {
      // console.log('here', newSIP?.start_date);

      return toast.error(
        `Start date should be greater than or equal to ${moment(
          todayDate
        ).format('DD-MM-YYYY')}`
      );
    }
    // console.log(couponCode, "@couponCode");

    if (couponCode?.length > 0) {
      // console.log(couponCode, "@couponCode");
      try {
        const metal = metalMapping[metalType] || metalType;

        const query = {
          metal: metal,
          orderAmount: newSIP?.installment_amt,
          orderMetalQuantity: 0,
          sipFrequency: newSIP?.frequency,
          sipDuration: newSIP?.duration,
          discountName: couponCode,
          // isSip: true,
        };
        const resp = await SipHttp.validateDiscountCoupon(query, customerId);
        if (resp) {
          if (resp.data.data[0].id) {
            // setCouponExpired(false);
            setCouponValidationError(null);
            setCouponData(resp.data.data[0]);
            setErrors(null);
            setErrorMessage('');
          } else {
            const errorMapping = resp.data.data.reduce((acc, curr) => {
              const [key, message] = Object.entries(curr)[0]; // Extract key and message from each error object
              acc[key] = message; // Set the key and its corresponding error message
              return acc;
            }, {});
            if (Object.keys(errorMapping).length >= 0) {
              setErrors(errorMapping);
              // setCouponCode(null);
              setCouponData(null);
              setErrorMessage('Sorry, Could not apply the coupon.');
            }
          }
        }
      } catch (error: any) {
        console.log(error, '@error');
        // setCouponExpired(true);
        setCouponValidationError(error?.data?.errors[0]?.title);
      }
    }
    setDislaySipSummary(true);
  };

  const handleClearCoupon = (setErrors) => {
    setCouponCode('');
    setIsCouponApplied(false);
    setErrors(null);
    setErrorMessage('');
    setCouponData(null);
    setCouponValidationError(null);
    setDislaySipSummary(false);
    setShowConfirmation(false);
    setNewSIP(prev=>({ ...prev, discount_name: '' }))
  };

  const onHandleSideModal = (value) => {
    setDislaySipSummary(false);
  };

  /**
   * Set initial state to razorpay data
   */
  // const setInitialStateRazorpay = () => {
  //   setRazorpay({
  //     customerId: customerId,
  //     amount: null,
  //     transactionTypeId: 'eb-o-00333',
  //     paymentMethod: 'NEBK',
  //   });
  // };

  // const checkPaymentStatus = async (paymentId, orderId) => {
  //   try {
  //     let payload = {
  //       paymentId,
  //       orderId,
  //     };
  //     setLoading(true);
  //     const res = await BuySellService.checkPaymentStatus(
  //       payload,
  //       abortControllerRef.current.signal
  //     );
  //   } catch (error) {
  //   } finally {
  //     setLoading(false);
  //     let newData = await getOrderDetails(orderId);
  //     return await handleOrderSummaryModal(newData);
  //   }
  // };

  // const setPaymentGatewayConfiguration = async (data) => {
  //   setLoading(false);
  //   const options: RazorpayOptions = {
  //     key: process.env.REACT_APP_RAZORPAY_KEY,
  //     amount: '',
  //     currency: 'INR',
  //     name: 'eBullion',
  //     description: 'Buy Metals',
  //     image:
  //       'https://ebullion-dev.s3.ap-south-1.amazonaws.com/assets/eb-logo.png',
  //     order_id: '',
  //     async handler(response: any) {
  //       setLoading(true);
  //       const payload = {
  //         customerId: razorpay.customerId,
  //         razorpayOrderId: response.razorpay_order_id,
  //         razorpayPaymentId: response.razorpay_payment_id,
  //         razorpaySignature: response.razorpay_signature,
  //         razorpayRequestBody: {
  //           amount: razorpay.amount,
  //           currency: 'INR',
  //           // test: 'testUPIwithRPY',
  //         },
  //       };

  //       // const res: any =
  //       //   paymentMethod === 'UPI'
  //       //     ? await BuySellService.verifyUPIPaymentRazorpay(payload)
  //       //     : await BuySellService.verifyNEBKPaymentRazorpay(payload);
  //       // if (res.status === 200 && res.data.data) {
  //       setInitialStateRazorpay();
  //       await checkPaymentStatus(
  //         response.razorpay_payment_id,
  //         data?.ebOrderRef
  //       );
  //       // }
  //     },
  //     prefill: {
  //       name: user.displayName,
  //       email: user.email.value,
  //       contact: user.mobile.value,
  //       method: paymentMethod === 'UPI' ? 'upi' : 'netbanking',
  //     },
  //     notes: {
  //       address: selectedAccount.billingAddress.address1,
  //     },
  //     theme: {
  //       hide_topbar: false,
  //       color: '#141034',
  //       backdrop_color: 'rgba(0, 0, 0, 0.90)',
  //     },
  //     timeout: 180,
  //   };

  //   // if (data.meta.payment.response.data.meta.length > 0) {
  //   //   options.order_id = data?.meta?.payment?.response.data.meta.filter(
  //   //     (data: any) => data.key === 'RPY_ORDER_ID'
  //   //   )[0].value;
  //   // }
  //   // razorpay.amount = data.meta.payment.response.data.amount;
  //   // options.amount = (razorpay.amount * 100).toString();
  //   // const razorPay = new Razorpay(options);
  //   // return razorPay.open();

  //   if (paymentMethod === 'UPI') {
  //     if (
  //       data.meta.payment.response.data.meta.length > 0 &&
  //       data?.meta?.payment?.response.data.meta.filter(
  //         (data: any) => data.key === 'PAYMENT_PROVIDER'
  //       )[0].value === 'RPY'
  //     ) {
  //       options.order_id = data?.meta?.payment?.response.data.meta.filter(
  //         (data: any) => data.key === 'RPY_ORDER_ID'
  //       )[0].value;
  //       razorpay.amount = data.meta.payment.response.data.amount;
  //       options.amount = (razorpay.amount * 100).toString();
  //       const razorPay = new Razorpay(options);
  //       return razorPay.open();
  //     } else {
  //       setInitialStateRazorpay();
  //       setLoading(false);
  //       await handleOrderSummaryModal(data);
  //     }
  //   }

  //   if (paymentMethod === 'NEBK') {
  //     if (data.meta.payment.response.data.meta.length > 0) {
  //       options.order_id = data?.meta?.payment?.response.data.meta.filter(
  //         (data: any) => data.key === 'RPY_ORDER_ID'
  //       )[0].value;
  //     }
  //     razorpay.amount = data.meta.payment.response.data.amount;
  //     options.amount = (razorpay.amount * 100).toString();
  //     const razorPay = new Razorpay(options);
  //     return razorPay.open();

  //     // const res: any = await BuySellService.buyWithNEBK(razorpay);
  //     // if (res.status === 200 && res.data.data.notes.length > 0) {
  //     //   setLoading(false);
  //     //   options.amount = (razorpay.amount * 100).toString();
  //     //   options.order_id = res.data.data.notes[0].rpyOrderId;
  //     //   const razorPay = new Razorpay(options);
  //     //   return razorPay.open();
  //     // }
  //   }
  // };
  // console.log('startDate', startDate);

  const handlePayManuallyClick = (e, { setErrors }) => {
    if (couponCode && couponCode.length > 0) {
      // Show modal if coupon code exists
      setShowModel(true);
    } else {
      // Directly set Pay Manually if no coupon code
      setErrors(null);
      setNewSIP(prev=>({
        ...prev,
        is_payment_manual: true,
        bank: '',
        start_date: dateFromDateString(todayDate),
      }));
      setEmandates('withMandateUPI');
      setSipMethod(e.target.value);
      // setStartDate(dateFromDateString(todayDate));
    }
  };

  const handleCancel = () => {
    setShowModel(false);
    setNewSIP(prev=>({
      ...prev,
      is_payment_manual: false,
      start_date: dateFromDateString(fivedaysAhead),
    }));
    // window.history.back(); // Go back to the previous page on cancel
  };

  const handleContinue = ({ setErrors }) => {
    setShowModel(false);
    // Proceed with Pay Manually setup and remove coupon
    setNewSIP(prev=>({
      ...prev,
      is_payment_manual: true,
      bank: '',
      start_date: dateFromDateString(todayDate),
      discount_name: '',
    }));
    setEmandates('withMandateUPI');
    setSipMethod('paymanual');
    // setStartDate(dateFromDateString(todayDate));
    setIsCouponApplied(false);
    setCouponCode('');
    setErrorMessage('');
    setErrors(null);
    setCouponData(null);
  };

  useEffect(() => {
    sipDailyLimitCheck();
    if (sipMethod !== 'paymanual') {
      if (newSIP?.frequency == 'daily') {
        setStartDate(dateFromDateString(twodaysAhead));
        setNewSIP(prev=>({
          ...prev,
          start_date: dateFromDateString(twodaysAhead),
        }));
      } else {
        setStartDate(dateFromDateString(fivedaysAhead));
        setNewSIP(prev=>({
          ...prev,
          start_date: dateFromDateString(fivedaysAhead),
        }));
      }
    }
  }, [newSIP?.frequency]);

  useEffect(() => {
    if (sipMethod === 'paymanual') {
      setStartDate(dateFromDateString(todayDate));
      setNewSIP((prev) => ({
        ...prev,
        start_date: dateFromDateString(todayDate),
      }));
    }
  }, [sipMethod]);


  // console.log('mp',)

  return (
    <Layout>
      <div style={{ backgroundColor: 'white' }}>
        {/* <PageHeader
          mainTitle={'user.displayName'}
          subTitle=''
        /> */}
        {/* <div className='saving-main-div'>
          <h4>Create new SIP</h4> */}
        <Formik
          initialValues={{
            plan_name: '',
            frequency: data.sipInterval,
            installment_amt: data?.installment_amt,
            grams: data?.sipGram,
            metal: data.sipMetalType,
            duration: '',
            bank: '',
          }}
          onSubmit={(values, { setSubmitting, setErrors }) => {
            setSubmitting(false);
            createSIP(values, { setErrors });
          }}
          validationSchema={validation}
        >
          {({
            values,
            isSubmitting,
            errors,
            touched,
            setErrors,
            setFieldValue,
            setFieldTouched,
            isValid,
            dirty,
          }) => (
            <FormikForm>
              <div className='saving-main-div'>
                <h4>Create new SIP</h4>
                <Card className='plan-card-com '>
                  {/* <pre>{JSON.stringify(values)}</pre>
                  <pre>{JSON.stringify(errors)}</pre>
                  <pre>{JSON.stringify(touched)}</pre> */}
                  <Card.Body>
                    <div className='saving-plan-container p-2'>
                      <div>
                        <Form.Group className='mb-3' controlId='orderType'>
                          <Form.Label>SIP plan name</Form.Label>
                          {/* <Form.Select
                      aria-label='Default select example'
                      name='qType'
                      // onChange={(e) => handleChangeFilter(e)}
                      value={'filter.qType'}
                    >
                      <option value='Gold'>Gold</option>
                      <option value='Silver'>Silver</option>
                      <option value='Platinum'>Platinum</option>
                      <option value='Palladium'>Palladium</option>
                    </Form.Select> */}
                          {/* <Form.Control
                          type='text'
                          value={sipPlanName}
                          onChange={(e) => setSipPlanName(e.target.value)}
                        /> */}
                          <Field
                            type='text'
                            placeholder=''
                            name='plan_name'
                            className='form-control'
                            onBlur={(e) => {
                              setFieldTouched('plan_name');
                            }}
                            onChange={(e: any) => {
                              setFieldValue('plan_name', e.target.value);
                              setNewSIP(prev=>({
                                ...prev,
                                plan_name: e.target.value,
                              }));
                              //   changeAddress(e);
                            }}
                            value={newSIP?.plan_name || ''}
                          />
                          <div className='error text-danger ml-2'>
                            {/* {errors.address1 && touched.address1 && (
                        <small id='my-helper-text '>{errors.address1}</small>
                      )} */}
                            <ErrorMessage name='plan_name'>
                              {(msg) => <span className='error'>{msg}</span>}
                            </ErrorMessage>
                          </div>

                          <Form.Label className='sip-margin'>
                            Precious Metal Type
                          </Form.Label>
                          <div className='radio-div sip-plan-radio-div'>
                            <Form.Check
                              type='radio'
                              label='Silver'
                              checked={metalType == 'Ag' ? true : false}
                              name='metal'
                              value={'Ag'}
                              onChange={(e) => {
                                setMetalType(e.target.value);
                                setNewSIP(prev=>({
                                  ...prev,
                                  metal: e.target.value,
                                }));
                              }}
                              className='custom-radio-button'
                            />
                            <Form.Check
                              type='radio'
                              checked={metalType == 'Au' ? true : false}
                              label='Gold'
                              name='metal'
                              value={'Au'}
                              onChange={(e) => {
                                setMetalType(e.target.value);
                                setNewSIP(prev=>({
                                  ...prev,
                                  metal: e.target.value,
                                }));
                              }}
                            />
                            <Form.Check
                              type='radio'
                              checked={metalType == 'Pt' ? true : false}
                              label='Platinum'
                              name='metal'
                              value={'Pt'}
                              onChange={(e) => {
                                setMetalType(e.target.value);
                                setNewSIP(prev=>({
                                  ...prev,
                                  metal: e.target.value,
                                }));
                              }}
                            />
                            <Form.Check
                              type='radio'
                              checked={metalType == 'Pd' ? true : false}
                              label='Palladium'
                              name='metal'
                              value={'Pd'}
                              onChange={(e) => {
                                setMetalType(e.target.value);
                                setNewSIP(prev=>({
                                  ...prev,
                                  metal: e.target.value,
                                }));
                              }}
                            />
                          </div>
                          <div className='error text-danger ml-2 mt-2'>
                            <ErrorMessage name='metal'>
                              {(msg) => <span className='error'>{msg}</span>}
                            </ErrorMessage>
                          </div>

                          <Form.Label className='sip-margin'>
                            Frequency
                          </Form.Label>
                          <div className='radio-div sip-plan-radio-div'>
                            <Form.Check
                              type='radio'
                              label='Daily'
                              checked={investInterval == 'daily' ? true : false}
                              name='payment-group'
                              value={'daily'}
                              onChange={(e) => {
                                setInvestInterval(e.target.value);
                                setNewSIP(prev=>({
                                  ...prev,
                                  frequency: e.target.value,
                                  start_date: dateFromDateString(twodaysAhead),
                                  bank: '',
                                }));
                                setStartDate(dateFromDateString(twodaysAhead));
                                setSipMethod('payemandate');
                                setEmandates('withMandateUPI');
                              }}
                            />
                            <Form.Check
                              type='radio'
                              label='Weekly'
                              checked={
                                investInterval == 'weekly' ? true : false
                              }
                              name='payment-group'
                              value={'weekly'}
                              onChange={(e) => {
                                setInvestInterval(e.target.value);
                                setNewSIP(prev=>({
                                  ...prev,
                                  frequency: e.target.value,
                                }));
                              }}
                            />
                            <Form.Check
                              type='radio'
                              checked={
                                investInterval == 'monthly' ? true : false
                              }
                              label='Monthly'
                              name='payment-group'
                              value={'monthly'}
                              onChange={(e) => {
                                setInvestInterval(e.target.value);
                                setNewSIP(prev=>({
                                  ...prev,
                                  frequency: e.target.value,
                                }));
                              }}
                            />
                          </div>
                          <div className='error text-danger ml-2 mt-2'>
                            <ErrorMessage name='frequency'>
                              {(msg) => <span className='error'>{msg}</span>}
                            </ErrorMessage>
                          </div>

                          <Form.Label className='sip-margin'>
                            Investment Amount
                          </Form.Label>
                          <CurrencyInput
                            disabled={investAmtField}
                            className='form-control'
                            name='installment_amt'
                            allowNegativeValue={false}
                            onWheel={(e: any) => e.target.blur()}
                            onValueChange={(value, name) => {
                              if (value !== null && Number(value) > 0) {
                                setSipAmount(value);
                                setNewSIP((prevSIP) => ({
                                  ...prevSIP,
                                  installment_amt: Number(value),
                                }));
                              } else {
                                setSipAmount(null);
                                setNewSIP((prevSIP) => ({
                                  ...prevSIP,
                                  installment_amt: Number(null),
                                }));
                              }
                              // Optional: Trigger validation manually only for this field
                            }}
                            value={newSIP?.installment_amt}
                            placeholder='₹ 0'
                            onChange={(e: any) => {
                              setFieldValue(
                                'installment_amt',
                                e.target.value,
                                false
                              ); // third param is `shouldValidate`, setting to false prevents validation
                              if (e.target.value === '') {
                                setInvestGramField(false);
                              } else {
                                setInvestGramField(true);
                              }
                            }}
                            maxLength={6}
                            decimalsLimit={2}
                          />

                          <div className='error text-danger ml-2'>
                            <ErrorMessage name='installment_amt'>
                              {(msg) => <span className='error'>{msg}</span>}
                            </ErrorMessage>
                          </div>
                          {/* <hr /> */}

                          {/* ------- Grams Input ------ */}
                          {/* <Form.Label className='sip-margin'>
                            Investment Quantity
                          </Form.Label>
                          <CurrencyInput
                            disabled={investGramField}
                            className='text-start form-control'
                            name='grams'
                            allowNegativeValue={false}
                            value={newSIP?.grams}
                            onWheel={(e: any) => e.target.blur()}
                            onValueChange={(value, name) => {
                              if (value !== null && Number(value) > 0) {
                                setSipGram(value);
                                setNewSIP({
                                  ...newSIP,
                                  grams: value,
                                });
                              } else {
                                setSipGram(null);
                                setNewSIP({
                                  ...newSIP,
                                  grams: null,
                                });
                              }
                            }}
                            onBlur={(e) => {
                              setFieldTouched('grams');
                            }}
                            onChange={(e: any) => {
                              setFieldValue('grams', e.target.value);

                              if (e.target.value == '') {
                                setInvestAmtField(false);
                              } else {
                                setInvestAmtField(true);
                              }
                            }}
                            // prefix={newSIP.installment_amt == '' ? '' : '₹ '}
                            decimalsLimit={4}
                            maxLength={7}
                            placeholder='0.0000 g'
                          />

                          <div className='error text-danger ml-2'>
                            <ErrorMessage name='grams'>
                              {(msg) => <span className='error'>{msg}</span>}
                            </ErrorMessage>
                          </div> */}

                          {/* <Datetime
                            timeFormat={''}
                            dateFormat={'DD/MM/YYYY'}
                            inputProps={{
                              placeholder: 'pick date',
                              className: 'focus:outline-none',
                            }}
                            className={`rounded-md shadow-sm appearance-none block w-full bg-grey-lighter text-grey-darker border border-grey-lighter rounded py-2 px-4`}
                            onChange={(event: any) =>
                              setNewSIP({
                                ...newSIP,
                                start_date: moment(
                                  new Date(event).toISOString()
                                ).format('MM/DD/YYYY'),
                              })
                            }
                            value={moment(newSIP.start_date)}
                            renderInput={(props) => {
                              return (
                                <input
                                  style={{ width: '100%' }}
                                  {...props}
                                  value={
                                    newSIP.start_date ? newSIP.start_date : ''
                                  }
                                />
                              );
                            }}
                          /> */}

                          <Form.Label className='sip-margin'>
                            SIP Duration
                          </Form.Label>
                          <Form.Select
                            aria-label='Default select example'
                            name='duration'
                            onChange={(e) => {
                              setSipType(e.target.value);
                              setNewSIP(prev=>({
                                ...prev,
                                duration: e.target.value,
                              }));
                            }}
                            value={newSIP?.duration}
                          >
                            <option value='3'>3 months</option>
                            <option value='6'>6 months</option>
                            <option value='9'>9 months</option>
                            <option value='12'>12 months</option>
                            <option value='24'>24 months</option>
                          </Form.Select>
                          <div className='error text-danger ml-2 mt-2'>
                            <ErrorMessage name='duration'>
                              {(msg) => <span className='error'>{msg}</span>}
                            </ErrorMessage>
                          </div>

                          <Form.Label className='sip-margin'>
                            Payment Method
                          </Form.Label>
                          <div className='d-flex justify-content-between'>
                            <Form.Check
                              type='radio'
                              label='E-Mandate'
                              name='paymentMethod'
                              value={'payemandate'}
                              onChange={(e) => {
                                setNewSIP(prev=>({
                                  ...prev,
                                  is_payment_manual: false,
                                  start_date: dateFromDateString(fivedaysAhead),
                                }));
                                setSipMethod(e.target.value);
                                if (newSIP?.frequency == 'daily') {
                                  setStartDate(
                                    dateFromDateString(twodaysAhead)
                                  );
                                  setNewSIP(prev=>({
                                    ...prev,
                                    start_date:
                                      dateFromDateString(twodaysAhead),
                                  }));
                                } else {
                                  setStartDate(
                                    dateFromDateString(fivedaysAhead)
                                  );
                                  setNewSIP(prev =>({
                                    ...prev,
                                    start_date:
                                      dateFromDateString(fivedaysAhead),
                                  }));
                                }
                              }}
                              checked={sipMethod == 'payemandate'}
                            />
                            {/* <Form.Check
                              type='radio'
                              label='Pay Manually'
                              name='paymentMethod'
                              value={'paymanual'}
                              onChange={(e) => {
                                setNewSIP({
                                  ...newSIP,
                                  is_payment_manual: true,
                                  bank: '',
                                  start_date: dateFromDateString(todayDate),
                                });
                                setEmandates('withMandateUPI');
                                setSipMethod(e.target.value);
                                setStartDate(dateFromDateString(todayDate));
                                setIsCouponApplied(false);
                                setShowModel(true);
                              }}
                              checked={sipMethod == 'paymanual'}
                            /> */}
                            {investInterval !== 'daily' && (
                              <Form.Check
                                type='radio'
                                label='Pay Manually'
                                name='paymentMethod'
                                value='paymanual'
                                onChange={(e) => {
                                  handlePayManuallyClick(e, { setErrors });
                                }}
                                checked={sipMethod === 'paymanual'}
                                disabled={investInterval == 'daily'}
                              />
                            )}
                            {showModel && (
                              <div
                                className='modal fade show d-block'
                                role='dialog'
                                style={{
                                  backgroundColor: 'rgba(0, 0, 0, 0.5)',
                                }}
                              >
                                <div
                                  className='modal-dialog modal-dialog-centered'
                                  role='document'
                                >
                                  <div className='modal-content'>
                                    <div className='modal-header'>
                                      <h5
                                        className='modal-title'
                                        style={{
                                          color: 'black',
                                          fontWeight: 'bold',
                                        }}
                                      >
                                        Coupon Not Applicable
                                      </h5>
                                   
                                    </div>
                                    <div
                                      className='modal-body'
                                      style={{
                                        color: 'black',
                                        fontSize: '14px',
                                      }}
                                    >
                                      <p>
                                        The coupon you applied is not applicable
                                        for the "Pay Manually" option. If you
                                        proceed, the coupon will be removed. Do
                                        you still wish to continue?
                                      </p>
                                    </div>
                                    <div className='modal-footer'>
                                      <button
                                        type='button'
                                        className='btn btn-secondary'
                                        onClick={handleCancel}
                                      >
                                        Cancel
                                      </button>
                                      <button
                                        type='button'
                                        className='btn btn-primary'
                                        onClick={() =>
                                          handleContinue({ setErrors })
                                        }
                                      >
                                        Continue
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>

                          {sipMethod == 'payemandate' && (
                            <div>
                              {/* <Form.Label className='sip-margin'>
                                E-Mandate
                              </Form.Label> */}
                              {/* {investInterval !== 'daily' && (
                                <>
                                  {emandateList?.length > 0 && (
                                    <div>
                                      <Form.Label
                                        className='sip-margin'
                                        style={{ color: '#99834d' }}
                                      >
                                        Use your existing mandate
                                      </Form.Label>
                                      <div className='d-flex align-items-center'>
                                        <Form.Check
                                          type='radio'
                                          name='Emandates'
                                          value={'withoutMandate'}
                                          checked={
                                            emandates == 'withoutMandate'
                                          }
                                          onChange={(e) => {
                                            setEmandates(e.target.value);
                                          }}
                                        />

                                        <Form.Control
                                          as='select'
                                          className='m-1'
                                          value={
                                            newSIP?.bank ? newSIP?.bank : ''
                                          }
                                          onChange={(e) =>
                                            setNewSIP({
                                              ...newSIP,
                                              bank: e.target.value,
                                            })
                                          }
                                          disabled={
                                            emandates == 'withoutMandate'
                                              ? false
                                              : true
                                          }
                                        >
                                          <option value='' disabled>
                                            Select Bank / UPI
                                          </option>
                                          {emandateList?.map((e, index) => (
                                            <option value={e?.bank} key={index}>
                                              {e?.bank != null
                                                ? e?.bank
                                                : e?.vpa}
                                            </option>
                                          ))}
                                        </Form.Control>
                                      </div>
                                    </div>
                                  )}
                                </>
                              )} */}

                              {/* <div>
                                <Form.Label
                                  className='sip-margin'
                                  style={{ color: '#99834d' }}
                                >
                                  Create New E-Mandate
                                </Form.Label>

                                <Form.Check
                                  type='radio'
                                  label='E-Mandate (NetBanking/Debit card)'
                                  name='Emandates'
                                  value={'withMandate'}
                                  onChange={(e) => {
                                    setNewSIP({ ...newSIP, bank: '' });
                                    setEmandates(e.target.value);
                                  }}
                                  checked={emandates == 'withMandate'}
                                />
                              </div> */}
                              <div>
                                <Form.Label
                                  className='sip-margin'
                                  style={{ color: '#99834d' }}
                                >
                                  Create New E-Mandate
                                </Form.Label>

                                <Form.Check
                                  type='radio'
                                  label='E-Mandate (UPI)'
                                  name='Emandates'
                                  value={'withMandateUPI'}
                                  onChange={(e) => {
                                    setNewSIP(prev=>({
                                      ...prev,
                                      bank: '',
                                      isupi: true,
                                    }));
                                    setEmandates(e.target.value);
                                  }}
                                  checked={emandates == 'withMandateUPI'}
                                />
                                {investInterval !== 'daily' && (
                                  <Form.Check
                                    type='radio'
                                    label='E-Mandate (NetBanking/Debit card)'
                                    name='Emandates'
                                    value={'withMandate'}
                                    onChange={(e) => {
                                      setNewSIP(prev=>({ ...prev, bank: '' }));
                                      setEmandates(e.target.value);
                                    }}
                                    checked={emandates == 'withMandate'}
                                    disabled={investInterval == 'daily'}
                                  />
                                )}
                              </div>
                            </div>
                          )}
                          <Form.Label className='sip-margin'>
                            Start date
                          </Form.Label>

                          <Form.Control
                            type='date'
                            name='start_date'
                            value={dateForPicker(startDate)}
                            placeholder='dd/mm/yyyy'
                            onChange={(e) => {
                              const selected = dateFromDateString(e.target.value);
                              setStartDate(selected);
                              setNewSIP(prev=>({
                                ...prev,
                                start_date: selected,
                              }));
                            }}
                            min={
                              sipMethod === 'paymanual'
                                ? todayDate
                                : newSIP?.frequency === 'daily'
                                  ? twodaysAhead
                                  : fivedaysAhead
                            }
                            max={thirtyDaysAhead} // prevent >30 days selection
                            onKeyDown={(e) => e.preventDefault()}
                          />

                          {isCouponApplied && couponCode && (
                            <>
                              <div
                                className='alert alert-success d-flex justify-content-between align-items-center'
                                role='alert'
                                style={{
                                  padding: '6px 10px',
                                  fontSize: '12px',
                                  marginTop: '14px',
                                }}
                              >
                                <div
                                  style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                  }}
                                >
                                  <svg
                                    xmlns='http://www.w3.org/2000/svg'
                                    width='16'
                                    height='16'
                                    fill='currentColor'
                                    className='bi bi-gift'
                                    viewBox='0 0 16 16'
                                    style={{ marginRight: '6px' }}
                                  >
                                    <path d='M3.5 0a3.5 3.5 0 0 1 2.45 5.95H10.5A3.5 3.5 0 1 1 13 5H3a3.5 3.5 0 0 1 .5-5zm0 1a2.5 2.5 0 0 0-1.995 4H5.5V1a2.5 2.5 0 0 0-2-.995zm9 0a2.5 2.5 0 0 0-2.5 2.5V5h4a2.5 2.5 0 0 0-1.5-4zM3.5 6h9a3.5 3.5 0 0 1 3.5 3.5v7a.5.5 0 0 1-.5.5H13V9H3v8H.5a.5.5 0 0 1-.5-.5v-7A3.5 3.5 0 0 1 3.5 6zM12 10v7h3.5a.5.5 0 0 0 .5-.5v-7A2.5 2.5 0 0 0 13.5 7h-1.5zm-8 0v7H.5a.5.5 0 0 1-.5-.5v-7a2.5 2.5 0 0 1 2.5-2.5H4z' />
                                  </svg>
                                  <strong style={{ fontSize: '13px' }}>
                                    Congratulations! Coupon "{couponCode}"
                                    applied to your SIP!
                                  </strong>
                                </div>
                                <button
                                  // onClick={() => {
                                  //   setCouponCode('');
                                  //   setCouponData(null);
                                  //   setIsCouponApplied(false);
                                  //   setErrors(null);
                                  //   setErrorMessage('');
                                  // }}
                                  onClick={() => setShowConfirmation(true)}
                                  style={{
                                    background: 'transparent',
                                    border: 'none',
                                    padding: '0',
                                    cursor: 'pointer',
                                  }}
                                >
                                  <svg
                                    xmlns='http://www.w3.org/2000/svg'
                                    width='16'
                                    height='16'
                                    fill='currentColor'
                                    viewBox='0 0 16 16'
                                    style={{ marginRight: '6px' }}
                                  >
                                    <path d='M16 8A8 8 0 1 1 8 0a8 8 0 0 1 8 8zM5.354 4.646a.5.5 0 0 0-.708.708L7.293 8 4.646 10.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z' />
                                  </svg>
                                </button>
                                {showConfirmation && (
                                  <div
                                    className='modal fade show d-block'
                                    role='dialog'
                                    style={{
                                      backgroundColor: 'rgba(0, 0, 0, 0.5)',
                                    }}
                                  >
                                    <div
                                      className='modal-dialog modal-dialog-centered'
                                      role='document'
                                    >
                                      <div className='modal-content'>
                                        <div className='modal-header'>
                                          <h5
                                            className='modal-title'
                                            style={{
                                              color: 'black',
                                              fontWeight: 'bold',
                                            }}
                                          >
                                            Confirm Action
                                          </h5>
                                          <button
                                            type='button'
                                            className='close'
                                            onClick={() => {
                                              setShowConfirmation(false);
                                              setDislaySipSummary(false);
                                            }}
                                          >
                                            <span>&times;</span>
                                          </button>
                                        </div>
                                        <div
                                          className='modal-body'
                                          style={{
                                            color: 'black',
                                            fontSize: '14px',
                                          }}
                                        >
                                          <p>
                                            Are you sure you want to remove the
                                            coupon?
                                          </p>
                                        </div>
                                        <div className='modal-footer'>
                                          <button
                                            onClick={() => {
                                              setShowConfirmation(true);
                                              handleClearCoupon(setErrors);
                                            }}
                                            className='btn btn-primary' // Changed to a proper button style
                                          >
                                            Yes
                                          </button>
                                          <button
                                            onClick={() => {
                                              setShowConfirmation(false);
                                              setDislaySipSummary(false);
                                            }}
                                            className='btn btn-secondary'
                                          >
                                            Cancel
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                )}
                              </div>
                            </>
                          )}

                          {showConfetti && isCouponApplied && couponCode && (
                            <div className='sip-confetti-container'>
                              {/* <ConfettiExplosion {...mediumProps} /> */}
                            </div>
                          )}

                          {sipMethod === 'payemandate' && (
                            <div className="d-flex align-items-center gap-2 sip-margin">
                              <Form.Check
                                type="checkbox"
                                id="sip-auto-renew"
                                checked={isSipAutoRenew}
                                onChange={(e) => {
                                  const checked = e.target.checked;

                                  setIsSipAutoRenew(checked);
                                  setNewSIP(prev => ({
                                    ...prev,
                                    is_auto_renew: checked,
                                  }));
                                }}
                              />

                              <span className="fw-medium">
                                Auto-renew this SIP after it ends
                              </span>
                              <OverlayTrigger
                                placement="right"
                                flip
                                popperConfig={{
                                  modifiers: [
                                    {
                                      name: 'flip',
                                      options: {
                                        fallbackPlacements: ['left', 'top', 'bottom'],
                                      },
                                    },
                                    {
                                      name: 'preventOverflow',
                                      options: {
                                        padding: 8,
                                      },
                                    },
                                  ],
                                }}
                                overlay={
                                  <Tooltip id="sip-auto-renewal-tooltip">
                                    Checking this option will create an Autopay OR Mandate for double the duration of SIP you are choosing and once your SIP expires, a new SIP will be created for you. You will have an option to uncheck this later on if you do not want a renewal.
                                  </Tooltip>
                                }
                              >
                                <span style={{ cursor: 'pointer', display: 'inline-flex' }}>
                                  <img src={infoIco} alt="Info" />
                                </span>
                              </OverlayTrigger>
                            </div>
                          )}


                          <div className='container_checkbox '>
                            <Form.Check
                              className='sip-margin '
                              type='checkbox'
                              label={
                                <>
                                  By creating this SIP, you agree to the{' '}
                                  <a
                                    href='https://ebullion.in/terms-and-conditions/terms.html'
                                    target='_blank'
                                    rel='noopener noreferrer'
                                    style={{
                                      color: '#99834d',
                                      textDecoration: 'underline',
                                    }}
                                  >
                                    Terms & Conditions
                                  </a>
                                </>
                              }
                              name='payment-group'
                              onClick={() => setIsConsented(!isConsented)}
                            ></Form.Check>
                          </div>
                        </Form.Group>

                        <Button
                          variant='primary'
                          className='btn-block mt-2'
                          type='submit'
                          size='lg'
                          disabled={!isConsented}
                        >
                          Create SIP
                        </Button>
                      </div>
                    </div>
                  </Card.Body>
                </Card>
              </div>
            </FormikForm>
          )}
        </Formik>

        <SipSummary
          key={'odrSmrpop'}
          handleModal={onHandleSideModal}
          isShow={dislaySipSummary && !showConfirmation}
          data={newSIP}
          displaySummary={true}
          emandates={emandates}
          sipMethod={sipMethod}
          errorMessage={errorMessage}
          successMessage={couponData}
          couponCode={couponCode}
          couponValidationError={couponValidationError}
        />
      </div>
    </Layout>
  );
};

export default SipSavingPlan;
